"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _SelectObjectContentEventStream_1 = require("./_SelectObjectContentEventStream");
exports.SelectObjectContentOutput = {
    type: "structure",
    required: [],
    members: {
        Payload: {
            shape: _SelectObjectContentEventStream_1._SelectObjectContentEventStream
        }
    },
    payload: "Payload"
};
//# sourceMappingURL=SelectObjectContentOutput.js.map